module.exports = __webpack_public_path__ + "static/navigator-c94e4a8ae424cfd10cf1bd94d54f73b0.png";